import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'templateTransform',
})
export class TemplateTransformPipe implements PipeTransform {
  transform(value: {[key: string]: any }, key: string): string | number | boolean | string[] {
    return value[key];
  }
}
